//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import storeMixins from '@/mixins/storeMixins'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ShowQuestion',
  mixins: [storeMixins],
  data: function () {
    return {
      packetId: this.$route.params.packet,
      timerColor: 'primary',
      outlineColor: 'primary',
      backgroundColor: 'black',
      urlRegex: /(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#](?:\S*[^\s!"'()*,-.:;<>?[\]_`{|}~]|))?/ig // https://gist.github.com/dperini/729294#gistcomment-2617741
    }
  },
  methods: {
    startOrStopTimer () {
      if (this.timerOn) {
        clearInterval(this.interval) // If timer is on, stop it
        this.changeTimerStatus()
      } else {
        if (this.timer > 0) {
          this.changeTimerStatus()
          this.interval = setInterval(() => {
            this.decrementTimer()
            if (this.timer <= 0) {
              this.timerColor = 'red'
              clearInterval(this.interval) // If timer is on, stop it
              navigator.vibrate(500)
              if (this.settings.soundOn) this.beep(10, 520, 500)
              this.changeTimerStatus()
            } else if (this.timer === 10) {
              this.timerColor = 'yellow'
              if (this.settings.soundOn) this.beep(10, 520, 200)
              navigator.vibrate(200)
            }
          }, 1000)
        }
      }
    },
    changeShowAnswer () {
      this.setShowAnswer(!this.showAnswer)
      if (this.showAnswer) {
        this.setUserPacketPlayed(this.packet.id)
        if ((this.tour.id === this.packet.tourIds[this.packet.tourIds.length - 1]) &&
        (this.question.id === this.tour.questionIds[this.tour.questionIds.length - 1])) {
          const userPacketAttribute = {
            id: this.packet.id,
            attribute: 'finishedAt',
            value: Date.now()
          }
          this.setUserPacketAttribute(userPacketAttribute)
        }
      }
      this.clearTimer()
    },
    toggleRightAnswer () {
      let attribute = {}
      if (this.userQuestion.solved === 'right') {
        attribute = {
          id: this.question.id,
          attribute: 'solved',
          value: null
        }
      } else {
        attribute = {
          id: this.question.id,
          attribute: 'solved',
          value: 'right'
        }
      }
      this.setUserQuestionAttribute(attribute)
    },
    toggleWrongAnswer () {
      let attribute = {}
      if (this.userQuestion.solved === 'wrong') {
        attribute = {
          id: this.question.id,
          attribute: 'solved',
          value: null
        }
      } else {
        attribute = {
          id: this.question.id,
          attribute: 'solved',
          value: 'wrong'
        }
      }
      this.setUserQuestionAttribute(attribute)
    },
    clearTimer () {
      clearInterval(this.interval)
      this.timerColor = 'primary'
      this.resetTimer()
    },
    beep (vol, freq, duration) {
      const audio = new AudioContext()
      const v = audio.createOscillator()
      const u = audio.createGain()
      v.connect(u)
      v.frequency.value = freq
      v.type = 'square'
      u.connect(audio.destination)
      u.gain.value = vol * 0.01
      v.start(audio.currentTime)
      v.stop(audio.currentTime + duration * 0.001)
    },
    ...mapActions('ui', [
      'setShowAnswer',
      'changeTimerStatus',
      'decrementTimer',
      'resetTimer'
    ]),
    ...mapActions('userPackets', [
      'setUserPacketPlayed',
      'setUserPacketAttribute'
    ]),
    ...mapActions('userQuestions', [
      'setUserQuestionAttribute'
    ])
  },
  computed: {
    beforeQuestionImage () {
      return this.question.question.split('@image@')[0]
    },
    afterQuestionImage () {
      return this.question.question.split('@image@')[1]
    },
    questionImageUrl () {
      return URL.createObjectURL(this.question.questionImage)
    },
    sourcesParsed () {
      return this.question.sources.replace(this.urlRegex, '<a href="$&" rel="external" target="_system">$&</a>')
    },
    beforeCommentsImage () {
      return this.question.comments.split('@image@')[0]
    },
    afterCommentsImage () {
      return this.question.comments.split('@image@')[1]
    },
    commentsImageUrl () {
      return URL.createObjectURL(this.question.commentsImage)
    },
    ...mapState('ui', ['showAnswer', 'timer', 'timerOn', 'settings'])
  },
  watch: {
    question: function () {
      this.clearTimer()
    }
  },
  created () {
    setInterval(() => {
      if (this.outlineColor === 'primary') {
        this.outlineColor = 'black'
        this.backgroundColor = 'primary'
      } else {
        this.outlineColor = 'primary'
        this.backgroundColor = 'black'
      }
    }, 2000)
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
    this.setShowAnswer(false)
  }
}
